import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Smartphone, X } from 'lucide-react';
import AppStoreBadges from './AppStoreBadges';

const KEY = 'df_app_strip_dismissed_at';
const HIDE_DAYS = 30;
const HIDDEN_PREFIXES = ['/dashboard', '/admin', '/api', '/realestate/dashboard', '/accounts'];

const Bar = styled.div`
  background: linear-gradient(90deg, #0369a1, #0891b2);
  color: #fff;
  padding: 8px 44px 8px 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 15px;
  font-weight: 700;
  svg.phone { width: 22px; height: 22px; }
  .label { display: inline-flex; align-items: center; gap: 8px; }
  button { position: absolute; right: 10px; top: 50%; transform: translateY(-50%); background: none; border: 0; color: #fff; opacity: 0.85; cursor: pointer; display: flex; padding: 4px; }
`;

const dismissedRecently = () => {
  try {
    const at = Number(localStorage.getItem(KEY));
    return at && Date.now() - at < HIDE_DAYS * 86400000;
  } catch {
    return false;
  }
};

/** A slim, dismissible "Get the app" strip shown on public pages: store icons, no sentence. */
export default function AppPromoStrip() {
  const { pathname } = useLocation();
  const [hidden, setHidden] = useState(dismissedRecently);
  if (hidden || HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  const close = () => {
    try { localStorage.setItem(KEY, String(Date.now())); } catch { /* private mode */ }
    setHidden(true);
  };

  return (
    <Bar>
      <span className="label"><Smartphone className="phone" /> Get the Desi Firms app</span>
      <AppStoreBadges center dark height={34} />
      <button type="button" onClick={close} aria-label="Dismiss"><X size={16} /></button>
    </Bar>
  );
}
